import c from 'classnames';
import Chain from '#assets/images/microbes/chain.svg?react';
import CurvedChain from '#assets/images/microbes/curved-chain.svg?react';
import Flagellate from '#assets/images/microbes/flagellate.svg?react';
import HookFlipped from '#assets/images/microbes/hook-flipped.svg?react';
import Hook from '#assets/images/microbes/hook.svg?react';
import TendrilRod from '#assets/images/microbes/tendril-rod.svg?react';
import styles from './MicrobesOutlineBg.module.css';

type MicrobesOutlineBgProps = {
  className?: string;
};

/**
 * Microbe outlines scattered around the edges of the nearest positioned
 * ancestor, which must create a stacking context — the scatter sits at
 * `z-index: -1` so it paints over that ancestor's background but under its
 * content.
 */
export function MicrobesOutlineBg({ className }: MicrobesOutlineBgProps) {
  return (
    <div aria-hidden className={c(styles.container, className)}>
      <Chain className={c(styles.microbe, styles.chainTop)} />
      <TendrilRod className={c(styles.microbe, styles.tendrilRod)} />
      <Hook className={c(styles.microbe, styles.hook)} />
      <HookFlipped className={c(styles.microbe, styles.hookFlipped)} />
      <CurvedChain className={c(styles.microbe, styles.curvedChain)} />
      <Flagellate className={c(styles.microbe, styles.flagellate)} />
      <Chain className={c(styles.microbe, styles.chainBottom)} />
    </div>
  );
}
